/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>房间维护</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.roomNo" placeholder="输入房间号"></el-input>
      </el-form-item>
      <el-form-item label="" prop="rooAttribute">
          <el-select size="small" v-model="formInline.rooAttributeId" clearable placeholder="请选择房间类型">
            <el-option v-for="type in roomAttributeList" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="" prop="roomStatus">
        <el-select size="small" v-model="formInline.roomStatus" clearable placeholder="请选择房间状态">
          <el-option v-for="type in roomStatusType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canManage()" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="roomNo" label="房间号" width="90">
      </el-table-column>
      <el-table-column sortable prop="rooAttribute.attributeName" label="房间类型" width="100">
      </el-table-column>
      <el-table-column sortable prop="blockNumber" label="楼号" width="70">
      </el-table-column>
      <el-table-column sortable prop="floor" label="楼层" width="70">
      </el-table-column>
      <el-table-column sortable prop="roomStatus" label="状态" width="70">
        <template v-slot="scope">
          <span v-if="scope.row.roomStatus === 0">异常</span>
          <span v-if="scope.row.roomStatus === 1">空房</span>
          <span v-if="scope.row.roomStatus === 2">已住</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="paidInPrice" label="实际房价" :formatter="(row) => formatNullValue(row.paidInPrice)" width="100">
      </el-table-column>
      <el-table-column sortable prop="deposit" label="押金" :formatter="(row) => formatNullValue(row.deposit)" width="80">
      </el-table-column>
      <el-table-column sortable prop="checkInTime" label="入住时间"  width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.checkInTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="checkOutTime" label="到期时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.checkOutTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="tenantName" label="租客" width="80" :formatter="(row) => formatNullValue(row.tenantName)">
      </el-table-column>
      <el-table-column prop="tenantPhone" label="租客电话" width="110" :formatter="(row) => formatNullValue(row.tenantPhone)">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleCheckInForm(scope.$index, scope.row)" v-show="$canEntry() && scope.row.roomStatus===1">入住</el-button>
          <el-button size="mini" type="success" @click="handleRenewForm(scope.$index, scope.row)" v-show="$canEntry() && scope.row.roomStatus===2">续费</el-button>
          <el-button size="mini" type="success" @click="handleCheckOutForm(scope.$index, scope.row)" v-show="$canEntry() && scope.row.roomStatus===2">退房</el-button>
          <el-button size="mini" type="warning" @click="handleTransferForm(scope.row)" v-show="$canEntry() && scope.row.roomStatus===2">换房</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="deleteRoom(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="房间号" prop="roomNo">
          <el-input size="small" v-model="editForm.roomNo" auto-complete="off" placeholder="请输入房间号"></el-input>
        </el-form-item>
        <el-form-item label="房间类型" prop="rooAttribute">
          <el-select size="small" v-model="editForm.rooAttributeId" placeholder="请选择房间类型">
            <el-option v-for="type in roomAttributeList" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼号" prop="blockNumber">
          <el-select size="small" v-model="editForm.blockNumber" placeholder="请选择楼号">
            <el-option v-for="type in blockNumberType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <el-select size="small" v-model="editForm.floor" placeholder="请选择楼层">
            <el-option v-for="type in floorType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="roomStatus">
          <el-select size="small" v-model="editForm.roomStatus" placeholder="请选择状态">
            <el-option v-for="type in roomStatusType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 入住界面 -->
    <el-dialog :title="checkInTitle" :visible.sync="checkInFormVisible" width="50%" @click="closeDialog('checkInForm')">
      <el-form label-width="120px" :model="checkInForm" :rules="checkInFormRules" ref="checkInForm">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="checkInDateTitle">
              <div class="block" >
                <el-date-picker
                  size="small"
                  style="width: 180px"
                  v-model="checkInForm.revenueDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="房号">
              <el-input size="small" v-model="checkInForm.roomNo"  placeholder="请输入房号" v-bind:disabled=roomNoDisable></el-input>
            </el-form-item>
            <el-form-item label="房租" >
              <el-input size="small"  v-model="checkInForm.roomCost" tabindex="1" @change="changeCost" :placeholder="roomGuidePrice" v-bind:disabled="roomCostVisible"></el-input>
            </el-form-item>
            <el-form-item label="网费" >
              <el-input size="small" v-model="checkInForm.networkCost" tabindex="3" @change="changeCost"  placeholder="请求输入房租收入"></el-input>
            </el-form-item>
            <el-form-item label="水费" >
              <el-input size="small" v-model="checkInForm.waterCost" @change="changeCost" tabindex="5" placeholder="请求输入水费收入"></el-input>
            </el-form-item>
            <el-form-item label="租客姓名" v-if="checkInTitle==='新入住'">
              <el-input size="small" v-model="checkInForm.tenantName" placeholder="请输入租客姓名"></el-input>
            </el-form-item>
            <el-form-item label="租客电话" v-if="checkInTitle==='新入住'">
              <el-input size="small" v-model="checkInForm.tenantPhone" placeholder="请输入租客电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时长(月)">
              <el-select size="small" v-model="checkInForm.periodValidity" clearable placeholder="请选择时长">
                <el-option v-for="type in periodValidityEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型">
              <el-select size="small" v-model="checkInForm.transType" clearable placeholder="请选择类型" v-bind:disabled=transTypeDisable>
                <el-option v-for="type in transTypeEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="押金" >
              <el-input size="small" v-model="checkInForm.depositCost" tabindex="2" @change="changeCost"  placeholder="请输入押金收入" v-bind:disabled="depositCostVisible"></el-input>
            </el-form-item>
            <el-form-item label="卫生费" >
              <el-input size="small" v-model="checkInForm.sanitationCost" tabindex="4" @change="changeCost"  placeholder="请输入押金收入"></el-input>
            </el-form-item>
            <el-form-item label="其他" >
              <el-input size="small" v-model="checkInForm.otherCost" @change="changeCost" tabindex="6"  placeholder="请输入其他收入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="费用合计">
          <el-input size="small" v-model="checkInForm.totalCost" auto-complete="off" placeholder="0" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCheckInForm('checkInForm')">确认</el-button>
      </div>
    </el-dialog>

    <!-- 退房界面 -->
    <el-dialog :title="checkOutTitle" :visible.sync="checkOutFormVisible" width="50%" @click="closeDialog('checkOutForm')">
      <el-form label-width="120px" :model="checkOutForm" :rules="checkOutFormRules" ref="checkInForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="房号">
              <el-input size="small" v-model="checkOutForm.roomNo" disabled></el-input>
            </el-form-item>
            <el-form-item label="押金总额" >
              <el-input size="small" v-model="checkOutForm.depositAmount" disabled></el-input>
            </el-form-item>
            <el-form-item label="扣除金额" >
              <el-input size="small"  v-model="checkOutForm.deductionAmount" tabindex="1" @change="changeDeductionAmount"  ></el-input>
            </el-form-item>
            <el-form-item label="备注" >
              <el-input size="small" v-model="checkOutForm.notes" tabindex="3" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入住时间">
              <div class="block" >
                <el-date-picker
                  size="small"
                  style="width: 180px"
                  v-model="checkOutForm.checkInTime"
                  type="date"
                  disabled
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="退款金额" >
              <el-input size="small" v-model="checkOutForm.refundAmount" disabled  placeholder="请输入押金收入"></el-input>
            </el-form-item>
            <el-form-item label="扣款描述">
              <el-input size="small" v-model="checkOutForm.deductionDescribe" tabindex="2" placeholder="请输入扣款描述"></el-input>
            </el-form-item>
            <el-form-item label="退款时间" >
              <div class="block" >
                <el-date-picker
                  size="small"
                  style="width: 180px"
                  v-model="checkOutForm.occurrenceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCheckOutForm('checkInForm')">确认</el-button>
      </div>
    </el-dialog>

    <!-- 换房界面：原房间结清水费后置空，租客、押金、到期日带到新房间 -->
    <el-dialog title="换房" :visible.sync="transferFormVisible" width="50%">
      <el-form label-width="120px" :model="transferForm" :rules="transferFormRules" ref="transferForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="原房间">
              <el-input size="small" v-model="transferForm.fromRoomNo" disabled></el-input>
            </el-form-item>
            <el-form-item label="上次水表">
              <el-input size="small" v-model="transferForm.oldWaterMeter" placeholder="如 30.4"></el-input>
            </el-form-item>
            <el-form-item label="结清水费" prop="waterCost">
              <el-input size="small" v-model="transferForm.waterCost"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input size="small" v-model="transferForm.notes" placeholder="选填"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="新房间" prop="toRoomNo">
              <el-select size="small" v-model="transferForm.toRoomNo" filterable placeholder="选择空房" style="width: 180px">
                <el-option v-for="room in vacantRooms" :key="room.roomNo" :value="room.roomNo"
                           :label="room.roomNo + (room.guidePrice ? '（' + room.guidePrice + '元）' : '')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="本次水表">
              <el-input size="small" v-model="transferForm.currentWaterMeter" placeholder="如 35.3"></el-input>
            </el-form-item>
            <el-form-item label="其他费用" prop="otherCost">
              <el-input size="small" v-model="transferForm.otherCost" placeholder="电费、补卡等"></el-input>
            </el-form-item>
            <el-form-item label="换房日期" prop="transferDate">
              <el-date-picker size="small" style="width: 180px" v-model="transferForm.transferDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="color: #909399; font-size: 12px; padding-left: 40px;">
          租客、押金 {{ transferForm.deposit === null ? '-' : transferForm.deposit }} 元、到期日 {{ formatDate(transferForm.checkOutTime) }} 带到新房间；
          不退押金、不算新住；下次续费起按新房间价格收。
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="transferFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitTransferForm">确认换房</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {roomList, roomAttributeType, roomSave, roomDelete, roomCheckIn, roomCheckOut, renew, roomTransfer} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      checkInFormVisible: false,//入住页面显示与隐藏
      checkOutFormVisible: false, //退房页面显示与隐藏
      transferFormVisible: false, //换房页面显示与隐藏
      vacantRooms: [],
      transferForm: {},
      transferFormRules: {
        toRoomNo: [{ required: true, message: '请选择新房间', trigger: 'change' }],
        transferDate: [{ required: true, message: '请选择换房日期', trigger: 'change' }],
        waterCost: [{ validator: (rule, value, callback) => (value === '' || value === null || Number(value) >= 0) ? callback() : callback(new Error('请输入不小于 0 的金额')), trigger: 'blur' }],
        otherCost: [{ validator: (rule, value, callback) => (value === '' || value === null || Number(value) >= 0) ? callback() : callback(new Error('请输入不小于 0 的金额')), trigger: 'blur' }]
      },
      depositCostVisible:false, // 押金输入框显示与隐藏
      roomCostVisible: false , // 房租输入框显示与隐藏
      roomGuidePrice: "",//房间价格描述
      transTypeDisable: true,
      periodValidityDisable: true,
      roomNoDisable: true,
      title: '添加',
      checkInTitle:"入住",
      checkInDateTitle:'',
      checkOutTitle:"退房",
      blockNumberType: [
        { key: '请选择', value: null},
        { key: 'A栋', value: 'A栋' },
        { key: 'B栋', value: 'B栋' },
        { key: 'C栋', value: 'C栋' }
      ],
      roomAttributeList:[],
      floorType:[
        { key: '请选择', value: null},
        {key:'二层',value:'2F'},
        {key:'三层',value:'3F'}
      ],
      roomStatusType: [
        { key: '请选择', value: null},
        { key: '异常', value: 0 },
        { key: '空房', value: 1 },
        { key: '已住', value: 2 },
      ],// 修改房间信息页面
      periodValidityEnum:[
        { key: '一周', value: 0.25},
        { key: '半月', value: 0.5},
        { key: '一月', value: 1},
        { key: '两月', value: 2},
        { key: '一季度', value: 3},
        { key: '半年', value: 6},
        { key: '一年', value: 12},
      ],
      transTypeEnum:[
        { key: '请选择', value: null},
        { key: '新住', value: 1},
        { key: '续费', value: 2},
        { key: '其他', value: 3},
      ],
      editForm: {
        roomId: '',
        roomNo: '',
        rooAttributeId: '',
        blockNumber: '',
        floor: '',
        roomStatus: '',
        checkInTime: '',
        checkOutTime: '',
        token: localStorage.getItem('logintoken')
      },// 入住页面
      checkInForm:{
        transId: '',
        revenueDate: "",
        depositCost: "",
        networkCost: "",
        otherCost: "",
        roomCost: "",
        roomNo: '',
        sanitationCost: "",
        periodValidity: "",
        totalCost: "",
        transType: '',
        waterCost: "",
        tenantName: "",
        tenantPhone: "",
        token: localStorage.getItem('logintoken')
      },
      checkOutForm:{
        id:'',
        roomNo:'',
        depositAmount:'',
        deductionAmount:'',
        deductionDescribe:'',
        refundAmount:'',
        notes:'',
        occurrenceTime:'',
        checkInTime:'',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        roomNo: [{ required: true, message: '请求输入房号', trigger: 'blur' }],
        rooAttributeId: [{ required: true, message: '请选择房型', trigger: 'blur' }]
      },// 入住数据校验
      checkInFormRules:{
        roomCost: [{ required: true, message: '请输入房租', trigger: 'blur' }]
      },// 退房数据校验
      checkOutFormRules:{
        roomNo: [{ required: true, message: '请输入房租', trigger: 'blur' }]
      },
      formInline: {
        current: 1,
        size: 10,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getRoomAttribute(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      roomList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 获取房型信息
    getRoomAttribute(){
      roomAttributeType()
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            let array = [];
            let obj1 = {};
            obj1.key='请选择'
            obj1.value=null
            array.push(obj1);

            res.data.forEach(obj => {
              let obj1 = {};
              obj1.key=obj.attributeName
              obj1.value=obj.id
              array.push(obj1);
            });
            this.roomAttributeList=array;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.roomId=row.roomId
        this.editForm.roomNo = row.roomNo
        this.editForm.rooAttributeId = row.rooAttributeId
        this.editForm.blockNumber = row.blockNumber
        this.editForm.floor=row.floor
        this.editForm.roomStatus=row.roomStatus
      } else {
        this.title = '添加'
        this.editForm.roomId=''
        this.editForm.roomNo = ''
        this.editForm.rooAttributeId = ''
        this.editForm.blockNumber = ''
        this.editForm.floor=''
        this.editForm.roomStatus=''
      }
    },//显示入住页面
    handleCheckInForm:function(index, row) {
      if(row.roomStatus!=1){
        this.$message.error('房间状态非空房,不允许入住！')
        return;
      }
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      this.checkInTitle='新入住'
      this.checkInDateTitle='入住日期'
      this.checkInForm.revenueDate= this.formatDate(currentDate);
      this.checkInForm.depositCost=  0
      this.checkInForm.networkCost= 0
      this.checkInForm.otherCost= 0
      this.checkInForm.roomCost= ""
      this.checkInForm.roomNo= row.roomNo;
      this.checkInForm.sanitationCost= 0
      this.checkInForm.periodValidity= 1
      this.checkInForm.totalCost= ""
      this.checkInForm.transType= 1
      this.checkInForm.waterCost= 0
      this.checkInForm.tenantName= ""
      this.checkInForm.tenantPhone= ""
      this.roomGuidePrice="指导价 "+row.rooAttribute.guidePrice
      this.checkInFormVisible = true
      this.depositCostVisible=false
      this.roomCostVisible=false
    },//显示退房页面
    handleCheckOutForm:function(index, row) {
      if(row.roomStatus!=2){
        this.$message.error('房间未入住,不允许退房！')
        return;
      }
      const currentDate = new Date();
      this.checkOutForm.occurrenceTime= this.formatDate(currentDate)
      this.checkOutForm.depositAmount=  row.deposit
      this.checkOutForm.deductionAmount= 0
      this.checkOutForm.deductionDescribe= ""
      this.checkOutForm.roomNo= row.roomNo
      this.checkOutForm.refundAmount= row.deposit;
      this.checkOutForm.checkInTime= row.checkInTime
      this.checkOutForm.notes='-'
      this.checkOutFormVisible = true
    },// 显示续费页面
    handleRenewForm:function(index, row) {
      if(row.roomStatus!=2){
        this.$message.error('房间状态非已入住,不允许续费！')
        return;
      }
      const currentDate = new Date();
      this.checkInTitle='续费'
      this.checkInDateTitle='续费日期'
      this.checkInForm.revenueDate= this.formatDate(currentDate);
      this.checkInForm.depositCost=  0
      this.checkInForm.networkCost= 0
      this.checkInForm.otherCost= 0
      this.checkInForm.roomCost= row.paidInPrice
      this.checkInForm.roomNo= row.roomNo;
      this.checkInForm.sanitationCost= 0
      this.checkInForm.periodValidity= 1
      this.checkInForm.totalCost= ""
      this.checkInForm.transType= 2
      this.checkInForm.waterCost= 0
      this.checkInFormVisible = true
      this.depositCostVisible=true
      this.roomCostVisible=false
      this.changeCost()

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          roomSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '房间保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('房间保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },// 入住数据
    submitCheckInForm(checkInForm){
      this.$refs[checkInForm].validate(valid => {
        // 判断校验结果
        if(!valid){
          return false
        }
        // 判断是续费还是新入住
        if(this.checkInTitle==='新入住'){
          this.doCheckIn()
        }else if(this.checkInTitle==='续费'){
          this.doRenew()
        }
      })
    },// 退房数据
    // 显示换房页面：新房间只能选空房
    handleTransferForm(row) {
      this.transferForm = {
        fromRoomNo: row.roomNo,
        toRoomNo: '',
        transferDate: this.formatDate(new Date()),
        oldWaterMeter: '',
        currentWaterMeter: '',
        waterCost: 0,
        otherCost: 0,
        notes: '',
        deposit: row.deposit,
        checkOutTime: row.checkOutTime
      }
      this.vacantRooms = []
      roomList({ current: 1, size: 1000, roomStatus: 1, token: localStorage.getItem('logintoken') })
        .then(res => {
          if (res.code === '200') this.vacantRooms = res.data.content
          else this.$message({ type: 'info', message: res.message })
        })
      this.transferFormVisible = true
      this.$nextTick(() => this.$refs.transferForm && this.$refs.transferForm.clearValidate())
    },
    submitTransferForm() {
      this.$refs.transferForm.validate(valid => {
        if (!valid) return false
        const f = this.transferForm
        const toNumber = v => (v === '' || v === null || v === undefined) ? null : Number(v)
        this.loading = true
        roomTransfer({
          fromRoomNo: f.fromRoomNo,
          toRoomNo: f.toRoomNo,
          transferDate: f.transferDate,
          waterCost: toNumber(f.waterCost),
          otherCost: toNumber(f.otherCost),
          oldWaterMeter: toNumber(f.oldWaterMeter),
          currentWaterMeter: toNumber(f.currentWaterMeter),
          notes: f.notes
        }).then(res => {
          this.loading = false
          if (res.code === '200') {
            this.transferFormVisible = false
            this.getdata(this.formInline)
            this.$message({ type: 'success', message: '换房成功：' + f.fromRoomNo + ' → ' + f.toRoomNo })
          } else {
            this.$message({ type: 'info', message: res.message })
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('换房失败，请稍后再试！')
        })
      })
    },
    submitCheckOutForm(checkOutForm){
      this.$refs[checkOutForm].validate(valid => {
        if (valid) {
          roomCheckOut(this.checkOutForm)
            .then(res => {
              this.checkOutFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '退房成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('退房失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },// 新入住
    doCheckIn(){
      roomCheckIn(this.checkInForm)
        .then(res => {
          this.checkInFormVisible = false
          this.loading = false
          if (res.code==='200') {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '入住成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('入住失败，请稍后再试！')
        })
    },// 续费
    doRenew(){
      renew(this.checkInForm)
        .then(res => {
          this.checkInFormVisible = false
          this.loading = false
          if (res.code==='200') {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '续费成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('续费失败，请稍后再试！')
        })
    }, // 删除房间
    deleteRoom(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          roomDelete([row.roomId])
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '房间已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.checkInFormVisible=false
      this.checkOutFormVisible=false
      this.transferFormVisible=false
    },
    //时间格式化显示
    formatDate (timestamp){
      if(timestamp===null){
        return '-';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },// 处理数据为空的展示效果
    formatNullValue(value){
      return value === null ? '-' : value;
    },// 变动数额计算合计数额
    changeCost(){
      let editForm = this.checkInForm;
      editForm.totalCost=Number(editForm.depositCost)+Number(editForm.networkCost)+Number(editForm.otherCost)
        +Number(editForm.roomCost)+Number(editForm.sanitationCost)+Number(editForm.waterCost);
    }, //退房页面扣款数额变动
    changeDeductionAmount(){
      let checkOutForm=this.checkOutForm;
      checkOutForm.refundAmount=checkOutForm.depositAmount-checkOutForm.deductionAmount;
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// src/views/basic/Room.vue